import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './controlinterno.css';

const HeaderSCI = ({ title }) => {
  const location = useLocation();

  const getBreadcrumb = () => {
    const path = location.pathname;
    const items = [];

    if (path.includes('/ControlInterno/Micrositio')) {
      items.push({ label: 'Micrositio SCI', path: '/ControlInterno/Micrositio' });
    } else if (path.includes('/ControlInterno')) {
      items.push({ label: 'Micrositio SCI', path: '/ControlInterno/Micrositio' });
      
      if (path.includes('/AntecedentesNormativos')) {
        items.push({ label: 'Antecedentes Normativos', path: '/ControlInterno/AntecedentesNormativos' });
      } else if (path.includes('/CarpetasDigitales')) {
        items.push({ label: 'Carpetas Digitales y Evidencias', path: '/ControlInterno/CarpetasDigitales' });
        if (path.includes('/CarpetasDigitales/2022')) {
          items.push({ label: 'Año 2022', path: '/ControlInterno/CarpetasDigitales/2022' });
        }
      } else if (path.includes('/ComponentesCI')) {
        items.push({ label: 'Componentes del Control Interno', path: '/ControlInterno/ComponentesCI' });
        if (path.includes('/AmbienteControl')) {
          items.push({ label: 'Ambiente de Control', path: '/ControlInterno/ComponentesCI/AmbienteControl' });
        } else if (path.includes('/ActividadesControl')) {
          items.push({ label: 'Actividades de Control', path: '/ControlInterno/ComponentesCI/ActividadesControl' });
        } else if (path.includes('/AdministracionRiesgos')) {
          items.push({ label: 'Administración de Riesgos', path: '/ControlInterno/ComponentesCI/AdministracionRiesgos' });
        } else if (path.includes('/InformacionComunicacion')) {
          items.push({ label: 'Información y Comunicación', path: '/ControlInterno/ComponentesCI/InformacionComunicacion' });
        } else if (path.includes('/Supervision')) {
          items.push({ label: 'Supervisión', path: '/ControlInterno/ComponentesCI/Supervision' });
        }
      } else if (path.includes('/EstructuraCOCODI')) {
        items.push({ label: 'Estructura del COCODI', path: '/ControlInterno/EstructuraCOCODI' });
      }
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumb();

  return (
    <>
      <div className="ci-breadcrumb-container">
        <nav className="ci-breadcrumb" aria-label="breadcrumb">
          {breadcrumbItems.map((item, index) => (
            <React.Fragment key={item.path}>
              {index > 0 && <span className="ci-breadcrumb-separator">&gt;</span>}
              {index === breadcrumbItems.length - 1 ? (
                <span className="ci-breadcrumb-current">{item.label}</span>
              ) : (
                <Link to={item.path} className="ci-breadcrumb-link">{item.label}</Link>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>

      <div className="ci-banner ci-banner--compact">
        <img
          className="ci-banner__deco ci-banner__deco--left"
          src="/micro/back_1.png"
          alt="Decoración izquierda"
        />

        <div className="ci-banner__center">
          <div className="ci-banner__inline">
            <img
              className="ci-banner__logo ci-banner__logo--sm"
              src="/micro/logo_micro.png"
              alt="Logo Contraloría"
            />
            <div className="ci-banner__inline-text">
              <p className="ci-banner__org ci-banner__org--sm">CONTRALORÍA</p>
              <p className="ci-banner__sub ci-banner__sub--sm">SECRETARÍA DE CONTRALORÍA</p>
            </div>
          </div>
          <p className="ci-banner__title ci-banner__title--single">
            {title}
          </p>
        </div>

        <img
          className="ci-banner__deco ci-banner__deco--right"
          src="/micro/back_2.png"
          alt="Decoración derecha"
        />
      </div>
    </>
  );
};

export default HeaderSCI;